module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "UpdateCBModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "title": "Update Information",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeModal
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "getin-due-date"
    }
  }, [_vm._v("Gate In Due Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "getin-due-date",
      "type": "date"
    },
    model: {
      value: (_vm.localData.getin_due_date),
      callback: function($$v) {
        _vm.$set(_vm.localData, "getin_due_date", $$v)
      },
      expression: "localData.getin_due_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "si-submission-date"
    }
  }, [_vm._v("SI Submission Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "si-submission-date",
      "type": "date"
    },
    model: {
      value: (_vm.localData.si_submission_date),
      callback: function($$v) {
        _vm.$set(_vm.localData, "si_submission_date", $$v)
      },
      expression: "localData.si_submission_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "vgm-submission-date"
    }
  }, [_vm._v("VGM Submission Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "vgm-submission-date",
      "type": "date"
    },
    model: {
      value: (_vm.localData.vgm_submission_date),
      callback: function($$v) {
        _vm.$set(_vm.localData, "vgm_submission_date", $$v)
      },
      expression: "localData.vgm_submission_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "tr-submission-date"
    }
  }, [_vm._v("TR Submission Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "tr-submission-date",
      "type": "date"
    },
    model: {
      value: (_vm.localData.tr_submission_date),
      callback: function($$v) {
        _vm.$set(_vm.localData, "tr_submission_date", $$v)
      },
      expression: "localData.tr_submission_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Liner BL Release Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mblInvoiceStatus,
      "id": "liner_bl_release_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select MBL Status"
    },
    model: {
      value: (_vm.localData.liner_bl_release_status),
      callback: function($$v) {
        _vm.$set(_vm.localData, "liner_bl_release_status", $$v)
      },
      expression: "localData.liner_bl_release_status"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Line Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.lineInvoiceStatus,
      "id": "line_inv_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Line Invoice Status"
    },
    model: {
      value: (_vm.localData.line_inv_status),
      callback: function($$v) {
        _vm.$set(_vm.localData, "line_inv_status", $$v)
      },
      expression: "localData.line_inv_status"
    }
  })], 1), _vm._v(" "), (_vm.localData.liner_bl_release_status == 1 && _vm.allModuleId > 0) ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('lable', [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type"
    },
    model: {
      value: (_vm.localData.blType),
      callback: function($$v) {
        _vm.$set(_vm.localData, "blType", $$v)
      },
      expression: "localData.blType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.blType))])], 1) : _vm._e(), _vm._v(" "), (_vm.localData.liner_bl_release_status == 1 && _vm.allModuleId > 0) ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('lable', [_vm._v("Liner Freght Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsLinerListName,
      "option-value": "frghtTermsLinerVal",
      "option-text": "frghtTermsLinerTxt",
      "placeholder": "Select Freght Terms"
    },
    model: {
      value: (_vm.localData.frghtTermsLiner),
      callback: function($$v) {
        _vm.$set(_vm.localData, "frghtTermsLiner", $$v)
      },
      expression: "localData.frghtTermsLiner"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.frghtTermsLiner))])], 1) : _vm._e(), _vm._v(" "), (_vm.localData.liner_bl_release_status == 1 && _vm.allModuleId > 0) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "mbl_release_date"
    }
  }, [_vm._v("MBL Release Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "mbl_release_date",
      "type": "date"
    },
    model: {
      value: (_vm.localData.mbl_release_date),
      callback: function($$v) {
        _vm.$set(_vm.localData, "mbl_release_date", $$v)
      },
      expression: "localData.mbl_release_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.mbl_release_date))])], 1) : _vm._e(), _vm._v(" "), (_vm.localData.liner_bl_release_status == 1 && _vm.allModuleId > 0) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "mbl_date"
    }
  }, [_vm._v("MBL Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "mbl_date",
      "type": "date"
    },
    model: {
      value: (_vm.localData.mbl_date),
      callback: function($$v) {
        _vm.$set(_vm.localData, "mbl_date", $$v)
      },
      expression: "localData.mbl_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.mbl_date))])], 1) : _vm._e(), _vm._v(" "), (_vm.localData.liner_bl_release_status == 1 && _vm.allModuleId > 0) ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('lable', [_vm._v("MBL Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "linerBLNumber",
      "name": "linerBLNumber"
    },
    model: {
      value: (_vm.localData.linerBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.localData, "linerBLNumber", $$v)
      },
      expression: "localData.linerBLNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.linerBLNumber))])], 1) : _vm._e(), _vm._v(" "), (_vm.localData.liner_bl_release_status == 1 && _vm.JobId > 0) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('lable', [_vm._v("MBL Upload ")]), _vm._v(" "), (_vm.JobAssNo && _vm.localData.linerBLupload) ? _c('a', {
    staticStyle: {
      "color": "purple",
      "font-size": "12px",
      "font-weight": "900"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + _vm.doc_path + "/" + (_vm.localData.linerBLupload.replaceAll('/', '_'))))
      }
    }
  }, [_vm._v("--View Doc")]) : _vm._e(), _vm._v(" "), (_vm.JobId > 0 && _vm.JobAssNo) ? _c('MultiFileUploader', {
    style: ("height: 79px;    background: darkgray;    width: 300px;"),
    attrs: {
      "documentName": 'Liner_BL',
      "otherDocName": 'Liner_BL',
      "folderName": 'Doc Library',
      "accept": '*',
      "assign_no": _vm.JobAssNo,
      "multiple": false,
      "state": Boolean(_vm.singleUpload),
      "fileAllModuleId": _vm.JobId.toString()
    },
    model: {
      value: (_vm.singleUpload),
      callback: function($$v) {
        _vm.singleUpload = $$v
      },
      expression: "singleUpload"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.JobId > 0) ? _c('span', [_vm._v("Choose a file or drop it above...")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.linerBLupload))]), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.localData.FBLCreatedBy) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b', {
    style: ('color:red;font-weight:bold;')
  }, [_vm._v("Created By:" + _vm._s(_vm.localData.FBLCreatedBy))])]) : _vm._e(), _vm._v(" "), (_vm.localData.FBLloginTime) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b', {
    style: ('color:red;font-weight:bold;')
  }, [_vm._v("Created At:" + _vm._s(_vm._f("moment")(_vm.localData.FBLloginTime)))])]) : _vm._e(), _vm._v(" "), (_vm.localData.FBLupdatedBy) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b', {
    style: ('color:red;font-weight:bold;')
  }, [_vm._v("Updated By:" + _vm._s(_vm.localData.FBLupdatedBy))])]) : _vm._e(), _vm._v(" "), (_vm.localData.FBLupdateTime) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b', {
    style: ('color:red;font-weight:bold;')
  }, [_vm._v("Updated At:" + _vm._s(_vm._f("moment")(_vm.localData.FBLupdateTime)))])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-end"
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1ee9ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pendency/UpdateCBModal.vue
// module id = 2437
// module chunks = 0